import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';
import D from '@assets/themes/dimensions';

export const Root = styled.div`
    height: ${D.COMMAND_BAR_HEIGHT}px;
    background-color: #424c57;
    padding: 0 47px 0px 16px;
    display: flex;
    gap:3px;
`;

export const OnlyViewContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: absolute;
    right: 65px;
    gap: 10px;
`

export const OnlyViewMessageContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 0px;
    height: 100%;
    box-sizing: border-box;
`

export const OnlyViewMessage = styled.div`
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${C.WHITE};
`

export const Divider = styled.div`
    margin: 10px;
    width: 1px;
    height: 100%;
    background-color: ${C.DARK_GRAY};
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    bottom: 10px; /* Ajuste para que quede en la parte inferior */
    right: 20px; /* Alineado a la derecha */
    gap: 10px;
`;
